<template>
  <div class="container-fluid" style="margin: -15px;">
    <div class="card">
      <div class="card-header bg-light">
        <h5 class="card-title">Reporte de Stock Actual</h5>
        <div class="row mb-2">
          <label class="col-md-1 text-end form-label">Fechas:</label>
          <div class="col-md-4">
            <div class="input-group">
              <input v-model="filters.fecha_desde" type="date" class="form-control">
              <span class="input-group-text">a</span>
              <input v-model="filters.fecha_hasta" type="date" class="form-control">
            </div>
          </div>
          <label class="col-md-1 text-end form-label">Categoría:</label>
          <div class="col-md-3">
            <select v-model="filters.categoria_id" class="form-select">
              <option value="">Todas</option>
              <option v-for="cat in categorias" :key="cat.id" :value="cat.id">
                {{ cat.id_partida }} : {{ cat.nombre_categoria }}
              </option>
            </select>
          </div>
          <!--
          <div class="col-md-2">
            <label class="form-label">Unidad</label>
            <select v-model="filters.unidad_id" class="form-select">
              <option value="">Todas</option>
              <option v-for="unidad in unidades" :key="unidad.id" :value="unidad.id">
                {{ unidad.nombre_unidad }}
              </option>
            </select>
          </div>
          -->
          <label class="col-md-1 text-end form-label">Tipo Bien</label>
          <div class="col-md-2">
            <select v-model="filters.partida_presupuestaria" class="form-select">
              <option value="">Todas</option>
              <option value="Consumo">Consumo</option>
              <option value="Valorado">Valorado</option>
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <label class="col-md-1 text-end form-label">Buscar</label>
          <div class="col-md-6">
            <div class="input-group">
              <input v-model="filters.search" type="text" class="form-control" placeholder="nombre Item, codigo...">
              <button @click="applyFilters" class="btn btn-primary">
                <i class="fas fa-search"></i>
              </button>
              <button @click="resetFilters" class="btn btn-secondary">
                <i class="fas fa-undo"></i>
              </button>
            </div>
          </div>
          <div class="col-md-4 text-end">
            <!--
            <button @click="exportKardexToPdf" class="btn btn-warning me-2">
              <i class="fas fa-file-alt me-2"></i> Reporte Kardex
            </button>
            -->
            <button @click="exportToPdf" class="btn btn-danger me-2">
              <i class="fas fa-file-pdf me-2"></i> Exportar PDF
            </button>
          </div>
        </div>
      </div>
      
      <div class="card-body">
        <div v-if="loading" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-2">Cargando reporte...</p>
        </div>
        
        <div v-else-if="stockData.length === 0" class="text-center py-5">
          <i class="fas fa-box-open fa-3x text-muted mb-3"></i>
          <h5>No se encontraron resultados</h5>
          <p class="text-muted">Ajusta los filtros e intenta nuevamente</p>
        </div>
        
        <div v-else>
          <div class="table-responsive">
            <table class="table table-sm table-striped table-hover">
              <thead>
                <tr style="font-size: 0.85em;">
                  <th>#</th>
                  <th>Item</th>
                  <th>Categoría</th>
                  <th>U.Medida</th>
                  <th class="text-end">Entradas</th>
                  <th class="text-end">Salidas</th>
                  <th class="text-end">Stock</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in stockData" :key="item.item_id" style="font-size: 0.85em;">
                  <td>{{ (pagination.current_page - 1) * pagination.per_page + index + 1 }}</td>
                  <td><span style="font-weight: bold;">{{ item.codigo }}:</span>{{ item.item }}</td>
                  <td>{{ item.id_partida || 'N/A' }} : {{ item.categoria || 'N/A' }}</td>
                  <td>{{ item.unidad_medida || 'N/A' }}</td>
                  <td class="text-end">{{ formatNumber(item.entradas) }}</td>
                  <td class="text-end">{{ formatNumber(item.salidas) }}</td>
                  <td class="text-end" :class="getStockClass(item.stock_actual)">
                    {{ formatNumber(item.stock_actual) }}
                  </td>
                  <td>
                    <button @click="showItemHistory(item)" class="btn btn-sm btn-info">
                      <i class="fas fa-history"></i> Historial
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="stockSummary">
                <tr>
                  <td colspan="5" class="text-end fw-bold">Totales:</td>
                  <td class="text-end fw-bold">{{ formatNumber(stockSummary.total_entradas) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(stockSummary.total_salidas) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(stockSummary.total_stock) }}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
          
          <!-- Paginación mejorada -->
          <div class="row mt-3">
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <span class="me-2">Mostrando:</span>
                <span class="fw-bold">
                  {{ ((pagination.current_page - 1) * pagination.per_page) + 1 }} -
                  {{ Math.min(pagination.current_page * pagination.per_page, pagination.total) }}
                  de {{ pagination.total }} registros
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <nav aria-label="Page navigation">
                <ul class="pagination justify-content-end">
                  <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                    <button class="page-link" @click="changePage(1)">
                      <i class="fas fa-angle-double-left"></i>
                    </button>
                  </li>
                  <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                    <button class="page-link" @click="changePage(pagination.current_page - 1)">
                      <i class="fas fa-angle-left"></i>
                    </button>
                  </li>
                  
                  <li v-for="page in visiblePages" :key="page" class="page-item" 
                      :class="{ active: page === pagination.current_page }">
                    <button class="page-link" @click="changePage(page)">
                      {{ page }}
                    </button>
                  </li>
                  
                  <li class="page-item" :class="{ disabled: pagination.current_page === pagination.last_page }">
                    <button class="page-link" @click="changePage(pagination.current_page + 1)">
                      <i class="fas fa-angle-right"></i>
                    </button>
                  </li>
                  <li class="page-item" :class="{ disabled: pagination.current_page === pagination.last_page }">
                    <button class="page-link" @click="changePage(pagination.last_page)">
                      <i class="fas fa-angle-double-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Historial -->
     
    <BModal
      v-model="historyModalVisible"
      title="Historial de Movimientos"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <div class="modal-body">
        <div v-if="historyLoading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mt-2">Cargando historial...</p>
        </div>
        
        <div v-else>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">Historial de: <strong>{{ currentItem?.item }}</strong></h6>
            <BBadge variant="info">{{ itemHistory.length }} movimientos</BBadge>
          </div>
          
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead class="table-light">
                <tr>
                  <th>Fecha</th>
                  <th>Tipo</th>
                  <th>Cantidad</th>
                  <th>Saldo</th>
                  <th>Referencia</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="movement in itemHistory" :key="movement.id">
                  <td>{{ formatDate(movement.fecha_movimiento) }}</td>
                  <td>
                    <BBadge 
                      :variant="movement.tipo_movimiento === 'entrada' ? 'success' : 'danger'"
                    >
                      {{ movement.tipo_movimiento.toUpperCase() }}
                    </BBadge>
                  </td>
                  <td class="text-end">{{ formatNumber(movement.cantidad) }}</td>
                  <td class="text-end">{{ formatNumber(movement.saldo_resultante) }}</td>
                  <td class="small">{{ movement.referencia || 'N/A' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div v-if="itemHistory.length === 0" class="text-center py-4">
            <i class="fas fa-history fa-2x text-muted mb-3"></i>
            <p class="text-muted">No hay movimientos registrados para este ítem</p>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <BButton
          variant="secondary"
          @click="historyModalVisible = false"
        >
          <i class="fas fa-times me-1"></i> Cerrar
        </BButton>
      </div>
    </BModal>
  </div>
</template>

<script setup>

import { ref, onMounted, computed, watch } from 'vue';
import axios from 'axios';
import { BModal, BButton, BBadge } from 'bootstrap-vue-3';

// Data
const stockData = ref([]);
const stockSummary = ref(null);
const unidades = ref([]);
const categorias = ref([]);
const loading = ref(false);

const historyModalVisible = ref(false);
const currentItem = ref(null);
const itemHistory = ref([]);
const historyLoading = ref(false);

// Filters - usando nombres consistentes con el backend
const filters = ref({
  search: '',
  fecha_desde: '',
  fecha_hasta: '',
  categoria_id: '',
  unidad_id: '',
  item_id: '',
  partida_presupuestaria: ''
});

// Pagination
const pagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  last_page: 1
});

// Computed
const visiblePages = computed(() => {
  const range = 2;
  const start = Math.max(1, pagination.value.current_page - range);
  const end = Math.min(pagination.value.last_page, pagination.value.current_page + range);
  
  const pages = [];
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }
  return pages;
});

// Methods
const fetchStock = async (page = 1) => {
  try {
    loading.value = true;
    pagination.value.current_page = page;
    
    const params = {
      ...filters.value,
      page: pagination.value.current_page,
      per_page: pagination.value.per_page
    };

    // Limpiar parámetros vacíos
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === '') {
        delete params[key];
      }
    });

    const response = await axios.get('/stock', { params });
    stockData.value = response.data.data;
    stockSummary.value = response.data.summary || null;
    
    // Actualizar paginación
    pagination.value = {
      current_page: response.data.current_page,
      per_page: parseInt(response.data.per_page),
      total: response.data.total,
      last_page: response.data.last_page
    };
  } catch (error) {
    console.error('Error fetching stock:', error);
  } finally {
    loading.value = false;
  }
};

const fetchUnidades = async () => {
  try {
    const response = await axios.get('/unidades');
    unidades.value = response.data;
  } catch (error) {
    console.error('Error fetching unidades:', error);
  }
};

const fetchCategorias = async () => {
  try {
    const response = await axios.get('/categoria/select');
    categorias.value = response.data.categorias;
  } catch (error) {
    console.error('Error fetching categorias:', error);
  }
};

const applyFilters = () => {
  pagination.value.current_page = 1;
  fetchStock();
};

const resetFilters = () => {
  filters.value = {
    search: '',
    fecha_desde: '',
    fecha_hasta: '',
    categoria_id: '',
    unidad_id: '',
    item_id: '',
    partida_presupuestaria: ''
  };
  pagination.value.current_page = 1;
  fetchStock();
};

const changePage = (page) => {
  if (page < 1 || page > pagination.value.last_page) return;
  fetchStock(page);
};
const showItemHistory = async (item) => {
  try {
    historyLoading.value = true;
    currentItem.value = item;
    
    const response = await axios.get(`/stock/${item.item_id}/history`);
    itemHistory.value = response.data.data?.kardex || response.data.kardex || [];
    
    historyModalVisible.value = true;
  } catch (error) {
    console.error('Error fetching item history:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudo cargar el historial del ítem'
    });
  } finally {
    historyLoading.value = false;
  }
};
// Formatear fecha
const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};
// Formatear números
const formatNumber = (num) => {
  return new Intl.NumberFormat('es-BO').format(num);
};

const getStockClass = (stock) => {
  if (stock > 0) return 'text-success fw-bold';
  if (stock < 0) return 'text-danger fw-bold';
  return 'text-warning fw-bold';
};

const exportToPdf = async () => {
  try {
    const params = { ...filters.value };
    
    // Limpiar parámetros de paginación
    delete params.page;
    delete params.per_page;

    const response = await axios.get('/stock/export-pdf', {
      params,
      responseType: 'blob'
    });
    
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `reporte-stock-${new Date().toISOString().split('T')[0]}.pdf`;
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('Error exporting to PDF:', error);
    alert('Error al generar el PDF');
  }
};

const exportKardexToPdf = async () => {
  try {
    const params = { ...filters.value };
    delete params.page;
    delete params.per_page;

    const response = await axios.get('/stock/kardex-report', {
      params,
      responseType: 'blob'
    });
    
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `reporte-kardex-${new Date().toISOString().split('T')[0]}.pdf`;
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('Error exporting kardex to PDF:', error);
    alert('Error al generar el reporte de kardex');
  }
};

// Watchers
watch([() => filters.value.fecha_desde, () => filters.value.fecha_hasta], ([newInicio, newFin]) => {
  if (newInicio && newFin && newInicio > newFin) {
    alert('La fecha de inicio no puede ser mayor a la fecha final');
    filters.value.fecha_desde = '';
    filters.value.fecha_hasta = '';
  }
});

// Lifecycle
onMounted(() => {
  fetchStock();
  fetchUnidades();
  fetchCategorias();
});
</script>

<style scoped>
.table-responsive {
  max-height: 65vh;
  overflow-y: auto;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #D84315;
  color:#ffffff;
  z-index: 10;
}

.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-warning {
  color: #ffc107 !important;
}

.page-item.active .page-link {
  background-color: #6ACFC7;
  border-color: #6ACFC7;
}

.page-link {
  color: #6ACFC7;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>